<template>
  <section class="container-fluid bg-white">
    <Table
      :data="userroles || []"
      :columns="table.columns"
      :actions="table.actions"
      :actionButton="table.actionButton"
      :disableSearch="false"
      :search="table.search"
      @rowClicked="table.clickHandler"
    />
  </section>
</template>

<script>
export default {
  data () {
    return {
      userroles: [],
      table: {
        columns: [
          {
            label: 'Name',
            property: 'name',
            searchable: true,
            sort: { enabled: true, default: true }
          }
        ],
        actions: [
          { icon: 'fas fa-trash-alt', buttonClass: 'btn-danger', action: this.deleteItem }
        ],
        actionButton: {
          icon: 'fa fa-plus',
          label: 'Create new user role',
          action: () => this.$router.push({ name: 'UserroleCreate' })
        },
        clickHandler: (item) => this.$router.push('/userroles/' + item.id),
        search: {
          placeholder: 'Search user roles',
          disabled: false
        }
      }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.$store
        .dispatch('getUserroles')
        .then(response => {
          this.userroles = response
          this.isLoading = false
        }).catch(error => {
          this.isLoading = false
          this.$swal({
            title: 'Error',
            text: 'Could not fetch userroles: ' + error,
            icon: 'error'
          })
        })
    },
    deleteItem (item, index) {
      this
        .$swal({
          title: 'Are you really sure?',
          text: 'The userrole "' + item.name + '" will be deleted. This cannot be undone!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          confirmButtonColor: '#dd4b39',
          cancelButtonText: 'Cancel'
        })
        .then(
          result => {
            if (result.value) {
              this.isLoading = true
              const data = {
                item: item
              }
              this.$store
                .dispatch('deleteUserrole', data)
                .then(response => {
                  this.userroles.splice(index, 1)
                  this.$swal({
                    title: 'Success',
                    text: 'Module "' + item.name + '" has been deleted',
                    icon: 'success',
                    showConfirmButton: false,
                    toast: true,
                    position: 'top',
                    timer: 2000
                  })
                  this.isLoading = false
                }).catch(error => {
                  this.isLoading = false
                  this.error = true
                  this.$swal({
                    title: 'Error',
                    text: 'could not delete userrole: ' + error,
                    icon: 'error'
                  })
                })
            }
          }
        )
    }
  }
}
</script>
